// @copyright  2006 - 2024 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'received-loan.page.title': 'Received Loans',
    'received-loan.page.repaid.title': 'Repaid Loans',
    'received-loan.page.search_results': 'Search Results',
    'received-loan.page.create.title': 'Create New Loan',
    'received-loan.page.search.title': 'Find Loans',
    'received-loan.page.edit.title': 'Edit Loan',
    'received-loan.page.view.title': 'View Loan',
    'received-loan.page.all': 'All',

    'received-loan.button.cancel': 'Cancel',
    'received-loan.button.select': 'Select',
    'received-loan.button.find': 'Find Loans',
    'received-loan.button.search': 'Apply',
    'received-loan.button.create': 'Create Loan',
    'received-loan.button.new': 'New Loan',
    'received-loan.button.save': 'Save Changes',
    'received-loan.button.repaid': 'Mark Repaid',
    'received-loan.button.edit': 'Edit',
    'received-loan.button.restore': 'Restore',
    'received-loan.button.reset': 'Reset',
    'received-loan.button.draft': 'Save Draft',
    'received-loan.button.cancel_draft': 'Cancel Draft',
    'received-loan.button.record_payment': 'Record Repayment',
    'received-loan.button.rollback': 'Rollback Loan',
    'received-loan.button.void': 'Void Loan',

    'received-loan.placeholder.search': 'Search received loans',

    'received-loan.link.create_first_received_loan': 'Click here to create your first loan',
    'received-loan.link.received_loans': ' Return to Received Loans',
    'received-loan.link.repaid': 'Repaid Loans',
    'received-loan.link.retry': 'Click here to retry',

    'received-loan.checkbox.all': 'Check All',
    'received-loan.checkbox.actions_label': 'with selected',

    'received-loan.label.entity_name': 'Institution',
    'received-loan.label.interest_rate': 'Interest Rate (%)',
    'received-loan.label.from_date': 'From Date',
    'received-loan.label.thru_date': 'Thru Date',
    'received-loan.label.currency_name': 'Currency',
    'received-loan.label.term_months': 'Term Months',
    'received-loan.label.currency_loan_amount_in_cents': 'Loan Amount',
    'received-loan.label.currency_monthly_payment_in_cents': 'Monthly Payment',
    'received-loan.label.currency_balance_owing_in_cents': 'Total Amount Repayable',
    'received-loan.label.currency_total_repaid_in_cents': 'Total Repaid',
    'received-loan.label.bank_general_ledger_account_name': 'Received In Bank Account',

    'received-loan.label.status': 'Status',
    'received-loan.label.void_reason': 'Reason for voiding loan',
    'received-loan.label.rollback_reason': 'Reason for rolling back loan',

    'received-loan.sort.field_label': 'Field',
    'received-loan.sort.direction_label': 'Direction',
    'received-loan.sort.direction_ascending': 'Ascending',
    'received-loan.sort.direction_descending': 'Descending',

    'received-loan.modal.title.received_loan_repaid': 'Mark Loan Repaid',
    'received-loan.modal.title.received_loan_restore': 'Restore Received Loan',
    'received-loan.modal.title.received_loan_rollback': 'Rollback Received Loan',
    'received-loan.modal.title.received_loan_void': 'Void Received Loan',

    'received-loan.modal.message.received_loan_repaid': 'Are you sure that you want to mark this loan repaid? | Are you sure that you want to mark these loans repaid?',
    'received-loan.modal.message.received_loan_restore': 'Are you sure that you want to restore this loan? | Are you sure that you want to restore these loans?',
    'received-loan.modal.message.received_loan_rollback': 'This action will remove the associated bank transaction.',
    'received-loan.modal.message.received_loan_void': 'This action will create a bank transaction to show that the funds were returned.',

    'received-loan.success.message.received_loan_created': 'Your loan has been created',
    'received-loan.success.message.received_loan_updated': 'Your loan has been updated',
    'received-loan.success.message.received_loan_restored': 'Your loan has been restored | All selected loans were restored',
    'received-loan.success.message.repaid_received_loans': 'Your loan was marked repaid | All selected loans were marked repaid',
    'received-loan.success.message.received_loan_voided': 'Your loan has been voided.',
    'received-loan.success.message.received_loan_rolled_back': 'Your loan has been rolled back.',
    'received-loan.success.message.received_loan_cancelled': 'Your draft loan has been cancelled.',

    'received-loan.error.message.repaid_received_loans': 'This loan was already marked repaid | These loans were already marked repaid',
    'received-loan.error.message.received_loan_restored': 'This loan was already restored | These loans were already restored',
    'received-loan.error.message.error_loading_page': 'Sorry, there was an error loading loan.| Sorry, there was an error loading loans.',

    'received-loan.message.search.no_repaid_received_loans': "You don't have any repaid loans.",
};
